// extracted by mini-css-extract-plugin
export var chevron = "_ja-4";
export var chevronExpanded = "_ja-5";
export var row = "_ja-0";
export var rowBody = "_ja-6";
export var rowDescription = "_ja-7";
export var rowHeader = "_ja-1";
export var rowTitle = "_ja-2";
export var rowTitleComplete = "_ja-3";